<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/skdYWn/images/9781439655955.jpg?1688985070195" alt="This image is the cover for the book Legendary Locals of Estes Park, Legendary Locals"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Legendary Locals of Estes Park, Legendary Locals
      </h1>
      <p class="bookDescription body article font2">
        <p>In the 1870s, ranchers Abner Sprague, William James, and Alexander MacGregor raised cattle while the Earl of Dunraven bought land for a private hunting reserve. It was neither  cows nor hunting that defined Estes Park, though. Visitors were attracted to its beauty and crystalline mountain air. Inspired by conservationist John Muir, Enos Mills preserved the area's splendor by spearheading the establishment of Rocky Mountain National Park while F.O. Stanley welcomed guests to his regal Stanley Hotel, the inspiration for Stephen King's novel The Shining. As cars replaced horses downtown, Charlie Eagle Plume entertained visitors with Indian dancing, and "Casey" Martin offered children rides on his Silver Streak train. In the off-season when tourists were scarce, grocer Ron Brodie extended credit to the locals, and George Hurt ran lifts for skiers at Hidden Valley. But it was adversity that tested the town and defined its character. After the 1982 Lawn Lake Flood inundated Elkhorn businesses, town officials revitalized the downtown landscape with urban renewal. When the devastating 2013 flood washed out mountain roads and isolated Estes Park, local businesses banded together and were "Mountain Strong."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Steve Mitchell
      </h2>
      
      <p class="authorDescription body article">Former reference librarian and freelance writer Steve Mitchell researched newspaper archives, interviewed family members, and tracked down photographs to compile this local history.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bed2047e